import React, { useContext } from 'react';

import { CrossIcon } from '@mc/wink-icons';
import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import IconButton from '../IconButton';
import { ModalCloseContext } from './Modal';

import stylesheet from './Modal.css';
import { ModalContext } from './ModalContext';

const ModalCloseButton = ({ size }: { size?: 'small' | 'medium' }) => {
  const modalSize = useContext(ModalContext)?.size;

  const isRedesigned = mcdsFlagCheck(
    'xp_mcds_redesign_components_organisms_part_2',
  );

  // If size is provided, use it, otherwise use the modal size (fallback to medium if large when flag is enabled), otherwise use medium
  const computedSize =
    size ||
    (isRedesigned && modalSize === 'large' ? 'medium' : modalSize) ||
    'medium';

  const onRequestClose = useContext(ModalCloseContext);
  // Translate default text
  const closeModalText = useDsTranslateMessage({
    id: 'mcds.modal.close_modal_text',
    defaultMessage: 'Close Modal',
  });

  return (
    <IconButton
      className={stylesheet.closeButton}
      icon={<CrossIcon />}
      label={closeModalText}
      // @ts-expect-error TS(2322) FIXME: Type 'unknown' is not assignable to type '(MouseEv... Remove this comment to see the full error message
      onClick={onRequestClose}
      {...(isRedesigned && {
        type: 'secondary',
        size: computedSize,
      })}
    />
  );
};

export default ModalCloseButton;
